export default __webpack_public_path__ + "static/media/Fona_en.b044c518.png";